export default __webpack_public_path__ + "static/media/11.6f5044d2.jpg";